import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activityLog: [],
  getAllActivityLog: []
};

export const ActivityLogSlice = createSlice({
  name: "activityLog",
  initialState,
  reducers: {
    getActivityLogAction: (state, action) => {
      state.activityLog = action.payload;
    },
  },
});

export default ActivityLogSlice.reducer;

export const { getActivityLogAction } = ActivityLogSlice.actions;
